import moment from "moment";
import ArrowRight from "../../svg/arrowRight";
import ConfigCardContent from "../configCardContent/configCardContent";

interface FormConfigCardProps {
  onArrowClick?: () => void;
  formTitle: string;
  createdAt: string;
  updatedAt: string;
  updatedBy?: string;
}

const FormConfigCard = ({
  onArrowClick,
  formTitle,
  createdAt,
  updatedAt,
  updatedBy,
}: FormConfigCardProps) => {
  return (
    <div className="flex w-full flex-row items-center justify-center rounded-md border border-primaryGray-14 shadow-md">
      <div className="flex w-full flex-row items-center justify-between p-3">
        <div className="flex w-1/4">
          <ConfigCardContent title="Form Name" description={formTitle} />
        </div>

        <div className="flex w-1/4">
          <ConfigCardContent
            title="Created On"
            description={moment(createdAt).format("DD MMMM YYYY")}
          />
        </div>

        <div className="flex w-1/4">
          <ConfigCardContent
            title="Updated On"
            description={moment(updatedAt).format("DD MMMM YYYY")}
          />
        </div>
        <div className="flex w-1/4">
          <ConfigCardContent
            title="Updated By"
            description={updatedBy ?? "--"}
          />
        </div>

        <div
          className="flex cursor-pointer flex-row items-center justify-center"
          onClick={onArrowClick ?? (() => {})}
        >
          <ArrowRight />
        </div>
      </div>
    </div>
  );
};

export default FormConfigCard;
